<template>
  <div ref="radice" class="relative inline-flex" data-test="ui-popover">
    <slot name="trigger" :aperto="aperto" :alterna="alterna" :attributi="attributiTrigger" />
    <div
      v-show="aperto"
      :id="idPannello"
      role="dialog"
      :aria-label="ariaLabel"
      tabindex="-1"
      class="glass-strong absolute z-40 w-[min(22rem,calc(100vw-2rem))] rounded-xl border border-glass-border p-4 shadow-xl"
      :class="[allineamento === 'fine' ? 'right-0' : 'left-0', sopra ? 'bottom-full mb-2' : 'top-full mt-2']"
      data-test="popover-pannello"
      @keydown.esc.stop="chiudi(true)"
    >
      <slot :chiudi="chiudi" />
    </div>
  </div>
</template>

<script setup lang="ts">
// Popover del design system: un pannello di vetro ancorato a un controllo (qui sotto o sopra, allineato al bordo), che si apre dal
// controllo, si chiude con Esc o con un tocco/clic fuori e riporta il focus al controllo. Il controllo lo disegna chi lo usa nello slot
// `trigger`, che riceve `attributi` (aria-expanded, aria-haspopup, aria-controls) e `alterna`. Il contenuto è lo slot predefinito.
import { useEventListener } from "@vueuse/core";

const props = withDefaults(defineProps<{ ariaLabel: string; allineamento?: "inizio" | "fine"; sopra?: boolean }>(), { allineamento: "fine", sopra: false });
const aperto = defineModel<boolean>("aperto", { default: false });

const idPannello = `${useId()}-popover`;
const radice = ref<HTMLElement | null>(null);

const attributiTrigger = computed(() => ({ "aria-expanded": aperto.value ? "true" : "false", "aria-haspopup": "dialog" as const, "aria-controls": idPannello }));
const alterna = () => (aperto.value = !aperto.value);

function chiudi(restituisciFocus = false): void {
  aperto.value = false;
  if (restituisciFocus) radice.value?.querySelector<HTMLElement>("button, [href], [tabindex]:not([tabindex='-1'])")?.focus();
}

useEventListener(typeof document === "undefined" ? undefined : document, "pointerdown", (e: Event) => {
  if (aperto.value && e.target instanceof Node && !radice.value?.contains(e.target)) aperto.value = false;
});
void props;
</script>
